"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.262 5.035c.746-1.061 1.927-1.861 3.57-1.861 1.281 0 2.258.337 2.985.944.717.599 1.118 1.398 1.371 2.19a.7.7 0 0 1-1.334.425c-.208-.653-.498-1.176-.934-1.54-.426-.355-1.063-.62-2.088-.62-1.123 0-1.902.524-2.424 1.267-.54.767-.795 1.764-.795 2.605 0 .623.149 1.237.326 1.963.09.37.187.767.258 1.186h4.019a.7.7 0 1 1 0 1.4h-3.912c-.002 1.544-.062 3.765-1.509 6.105 1.348-.437 2.993-.816 4.529-.052 1.323.657 2.676.422 3.9-.429a.7.7 0 0 1 .8 1.15c-1.544 1.073-3.443 1.467-5.323.533-1.14-.567-2.454-.223-3.956.29a1.18 1.18 0 0 1-1.375-.466 1.26 1.26 0 0 1 .007-1.414c1.452-2.12 1.524-4.14 1.527-5.717H6.377a.7.7 0 1 1 0-1.4h2.396c-.055-.277-.123-.56-.194-.854l-.016-.065c-.165-.676-.35-1.435-.35-2.23 0-1.084.32-2.372 1.05-3.41",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyBritishPoundIcon24.js.map